export const DEFAULT_PAGE_SIZE_PARTIAL = 3;
export const DEFAULT_PAGE_SIZE = 30;

export const SEARCH_DEBOUNCE_TIME = 800;
export const SEARCH_PARTIAL_DEBOUNCE_TIME = 1100;
export const MIN_PARTIAL_SEARCH_LENGTH = 2;
